export default [
	{ id: 2, name: "normal", val: -3, shortName: "N" },
	{ id: 3, name: "heroic", val: -2, shortName: "H" },
	{ id: 4, name: "mythic", val: -1, shortName: "M" }
];